import { useState, useRef, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faArrowRight, faClose } from "@fortawesome/free-solid-svg-icons";
import { useAppSelector } from "Redux/hooks";
import { selectStyle } from "Redux/appSlice";

type Props = {
  cards: any[];
  pageSize?: number;
  setShowResult: (arg1: boolean) => void;
};

/*
  @function SearchShower
  show children and navigate through them
  @params children {React.Node} - search children
  @params pageSize {number} - size of the searchbar
  @returns {React.Node}
*/
export default function SearchShower({ cards = [], pageSize = 10, setShowResult = (arg1: boolean) => {} }: Props) {
  const [page, setPage] = useState(0);
  const { color1, color2} = useAppSelector(selectStyle);
  const barRef = useRef(null);

  useEffect(() => {
    setPage(0);
  }, [cards]);

  const onPageChange = (direction: string) => {
    if (direction === "left" && page !== 0) {
      setPage((state) => state - 1);
    }
    if (direction === "right" && page < Math.ceil(cards.length / pageSize)) {
      setPage((state) => state + 1);
    }
  };

  cards.sort((a, b) => a.props.chapter.localeCompare(b.props.chapter));

  return (
    <div
      ref={barRef}
      className={`absolute left-1/2 top-8 w-full -z-10 -translate-x-1/2 p-4 pt-12 h-64 justify-between flex flex-row space-around ${
        cards.length !== 0 ? "" : "hidden"
      }`}
      style={{ backgroundColor: color1 }}
    >
      <button
        className=" mx-4 px-4"
        style={{ background: color2 }}
        onClick={() => onPageChange("left")}
      >
        <FontAwesomeIcon icon={faArrowLeft} color={color1} />
      </button>

      <div className="flex flex-row  space-x-4 ">
        {cards.slice(pageSize * page, pageSize * (page + 1))}
      </div>
      <div className="flex flex-row justify-end">
        <button
          className="bg-red-500 mx-4 px-4"
          onClick={() => onPageChange("right")}
          style={{ background: color2 }}
        >
          <FontAwesomeIcon icon={faArrowRight} color={color2} />
        </button>
        <button
          className="bg-red-500 px-4"
          onClick={() => setShowResult(false)}
          style={{ background: color2 }}
        >
          <FontAwesomeIcon icon={faClose} color={color2} />
        </button>
      </div>
    </div>
  );
}
